// Request context the listing controller derives from the URL path, not filters: it is seeded
// from the SSR props, sent along with every fetch (the category slugs, which the base-path
// fetch cannot carry in its URL) and never reset by a filter change or a popstate restore.
export const initialRouteState = {
  parentCategorySlug: undefined,
  subcategorySlug: undefined,
  // Localized canonical URL of the last fetched results. Empty until the first fetch: the SSR
  // `url` prop is the backend's locale-less path, so consumers fall back to their SSR base URL.
  canonicalUrl: '',
}
